import * as actionTypes from './actionsTypes';
import axios from '../../http-config';

import swal from 'sweetalert'

export const fetchLoadsSuccess = (response) => {
    return {
        type: actionTypes.FETCH_LOADS_SUCCESS,
        loads: response.data.loads,
        totalCount: response.totalCount,
      
    }
}
export const fetcSampleFilesSuccess = (response) => {
    return {
        type: actionTypes.FETCH_CONFIG_SUCCESS,
        config: response.data.ulbs,
    }
}

export const fetchLoadsFail = (error) => {
    return {
        type: actionTypes.FETCH_LOADS_FAIL,
        error:error
    }
}

export const fetchLoadsStart = () => {
    return {
        type: actionTypes.FETCH_LOADS_START
    }
}
export const fetchOperatorListingSuccess = (response) => {
    return {
        type: actionTypes.FETCH_OPERATORLISTING_LOAD_SUCCESS,
        operaters: response.data.operators,
        totalCount: response.totalCount,
    }
}
export const fetchTrucksListingSuccess = (response)=>{
    return {
        type: actionTypes.FETCH_TRUCKLISTING_LOAD_SUCCESS,
        Trucks: response.data.trucks,
        totalCount: response.totalCount,
    }
}
export const fetchLoads = (payload) => {
    let limit = payload.limit;
    let page = payload.page;
    let sort = payload.sort;
    let filter = payload.filter;
    let query = payload.query;
    let requestId = payload.requestId
    let token = payload.token;
    let ulbId = payload.ulbId
    let fromDate=payload.fromDate
    let toDate=payload.toDate
    let url;
    return dispatch => {
        dispatch(fetchLoadsStart());
    //     load/?limit=10&page=1&sort=&query=&fromDate=01-01-2020%2000:00&toDate=10-04-2021%2023:59&operatorId=31
    // const searchD = payload.searchByFields=="propertyName"? `PropertyBuildingName=${query}`: payload.searchByFields == "request" ? `requestId=${query}`:""
        if(query){
         url =  ulbId == "" ? `/load/?limit=${limit}&page=${page}&sort=${sort}&filter=${filter}&query=${query}` : 
        `/load/?limit=${limit}&page=${page}&sort=${sort}&filter=${filter}&query=${query}&ulbId=${payload.ulbId}&fromDate=${fromDate}&toDate=${toDate}`;
        }
        else{
         url =  ulbId == "" ? `/load/?limit=${limit}&page=${page}&sort=${sort}&filter=${filter}&query=${query}` : 
        `/load/?limit=${limit}&page=${page}&sort=${sort}&filter=${filter}&requestId=${requestId}&ulbId=${payload.ulbId}&fromDate=${fromDate}&toDate=${toDate}`;
        }
        

        axios({
            method: 'get',
            url: url,
            headers: {'Authorization': `Bearer ${token}`}
        })
        .then(function (response) {
            const fetchedLoadsResponse = response.data;
            dispatch(fetchLoadsSuccess(fetchedLoadsResponse));
        }).catch(error => {
            dispatch(fetchLoadsFail(error));
        })
        }
}

export const fetchLoadsPerProperty = (payload) => {
    return dispatch => {
        dispatch(fetchLoadsStart());
        const url = `property/${payload.ulbId}/load?limit=${payload.limit}&page=${payload.page}`;
        axios({
            method: 'get',
            url: url,
            headers: {'Authorization': `Bearer ${payload.token}`}
        })
        .then(function (response) {
            const fetchedLoadsResponse = {
                "data" : {
                    "loads" : response.data.data.propertyLoads
                }
            }
            dispatch(fetchLoadsSuccess(fetchedLoadsResponse));
        }).catch(error => {
            dispatch(fetchLoadsFail(error));
        })
    }
}


export const editLoads = (formdata,props) => {
let token=localStorage.getItem('token');
    return dispatch => {
        dispatch(fetchLoadsStart());
        const url = '/load'
        
        axios.post(url,formdata,{headers:{
            "Authorization":`Bearer ${token}`
        }})
        .then(function (response) {
            const fetchedLoadsResponse = response.data.success;
            fetchedLoadsResponse && swal({
                title: "Data Edited",
                icon: "success",
                buttons: {
                    confirm: 'Ok'
                }
              })
              .then((edit) => {
                if (edit) {
                props.history.push('/records/all')  
                } 
              });
            dispatch(fetchLoadsSuccess(fetchedLoadsResponse));
        }).catch(error => {
            dispatch(fetchLoadsFail(error));
        })
    }
}

export const deleteRecords = (payload,props) => {
    return (dispatch) => {
        dispatch(fetchLoadsStart())
        const url =  `load/${payload.id}`
        axios.delete(url , { data : payload, headers : {   "Authorization":`Bearer ${payload.token}`} })
        .then((response) => {
            response && swal({
                title: "Data Deleted",
                icon: "success",
                buttons: {
                    confirm: 'Ok'
                }
              })
              .then((edit) => {
                if (edit) {
                props.history.push('/records/all')  
                } 
              });
            dispatch(fetchLoads(payload));
        }, 
        (err) => {
            swal({icon : "error" , title : err.response.data.error[0]["message"]}) 
        })
        props.history.push('/records/all')  
    }
}

export const filterLoads = (payload) => {
    let limit = payload.limit;
    let page = payload.page;
    let sort = payload.sort;
    let filter = payload.filter;
    let query = payload.query;
    let token = payload.token;
    let fromDate=payload.fromDate
    let toDate=payload.toDate
    let ulbId = payload.ulbId
    let operatorID = payload.operatorId
    return dispatch => {
        dispatch(fetchLoadsStart());
        // const searchData = payload.searchByFields=="propertyName"? `PropertyBuildingName=${query}`: payload.searchByFields == "request" ? `requestId=${query}`:""
        
    const url = ulbId === ''&&operatorID ==''?`/load/?sort=${sort}&filter=${filter}&query=${query}&fromDate=${fromDate}&toDate=${toDate}`:
    ulbId !=""&&operatorID !== ""?  `/load/?limit=${limit}&page=${page}&sort=${sort}&filter=${filter}&query=${query}&fromDate=${fromDate}&toDate=${toDate}`:  ulbId !=""&&operatorID == ""?  `/load/?limit=${limit}&page=${page}&sort=${sort}&filter=${filter}&query=${query}&ulbId=${ulbId}&fromDate=${fromDate}&toDate=${toDate}`:'';
    const url2 = ulbId === ''&&operatorID ==''?`/load/?sort=${sort}&filter=${filter}&requestId=${query}&fromDate=${fromDate}&toDate=${toDate}`:
    ulbId !=""&&operatorID !== ""?  `/load/?limit=${limit}&page=${page}&sort=${sort}&filter=${filter}&requestId=${query}&fromDate=${fromDate}&toDate=${toDate}`:  ulbId !=""&&operatorID == ""?  `/load/?limit=${limit}&page=${page}&sort=${sort}&filter=${filter}&requestId=${query}&ulbId=${ulbId}&fromDate=${fromDate}&toDate=${toDate}`:'';
      axios({
            method: 'get',
            url: payload.searchByFields=="propertyName"?url:(payload.searchByFields=="request"?url2:url),
            headers: {'Authorization': `Bearer ${token}`}
        })
        .then(function (response) {
            const fetchedLoadsResponse = response.data;
            
            dispatch(fetchLoadsSuccess(fetchedLoadsResponse));
        }).catch(error => {
            dispatch(fetchLoadsFail(error));
        })
    }
}

export const fetchBulkImport = (payload,formData, props) => {
    let token = payload.token
    return dispatch => {
        dispatch(fetchLoadsStart());
        const url = '/load/bulk'

        axios.post(url,formData,{headers:{
            "Authorization":`Bearer ${token}`
        }})
        .then(function (response) {
            if(response){
                const fetchedLoadsResponse = response.data.success;
                fetchedLoadsResponse && swal({
                    title: "Data Imported",
                    icon: "success",
                    buttons: {
                        confirm: 'Ok'
                    }
                  })
                  .then((bulk) => {
                    if (bulk) {
                    dispatch(fetchLoads(payload))
                    } 
                  });
            }
              
        }, (err) => {
            if(err.response.data.error.length ===1){
                swal({
                    title:err.response.data.error[0].errmessage,
                    icon: "error",
                    buttons: {
                        confirm: 'Ok'
                    }
                  })
                  props.history.push('/records/all')
            }
            else{
                const errors = !!err.response.data.error? err.response.data.error.length : ''
                let list = '';
                var myhtml = document.createElement("div");
                myhtml.className = 'textNode-content';
                 for(let i = 0; i<errors; i++){
                     list += '*'  + err.response.data.error[i].errmessage +'  '+ '.' +'\n';
                    
                 }
                 myhtml.innerHTML = list
                 swal({icon : "error" , content: myhtml})   
                 props.history.push('/records/all')
            }
        
        })
        .catch(error => {
            dispatch(fetchLoadsFail(error));
        })

    }
}


export const DownloadSampleFile =()=>{
    let token=localStorage.getItem('token');
    return dispatch =>{
        dispatch(fetchLoadsStart());
        const url = '/ulb/user_ulb';
        axios.get(url, {headers: {'Authorization': `Bearer ${token}`}})
        .then(res=>{
            dispatch(fetcSampleFilesSuccess(res.data))
        })
        .catch(error=>{
            dispatch(fetchLoadsFail(error));
        })
    }
}

export const OpertaterList =(payload)=>{
    const api= '/operator/'

    let token = payload.token;
    return dispatch => {
        dispatch(fetchLoadsStart());
        axios({
            method : 'get',
            url : api,
            headers :  {'Authorization': `Bearer ${token}`}
        })
        .then((response) => {
            const fetchedoperatorListingResponse = response.data
            dispatch(fetchOperatorListingSuccess(fetchedoperatorListingResponse));
        })
        .catch((err) => {
            dispatch(fetchLoadsFail(err))
        })
    }

}

export const trucksList =(payload)=>{
    const api = `/truck?operatorId=${payload.operatorId}`
    let token = payload.token;
    return dispatch => {
        dispatch(fetchLoadsStart());
        axios({
            method : 'get',
            url : api,
            headers :  {'Authorization': `Bearer ${token}`}
        })
        .then((response) => {
            const fetchedTrucksListingResponse = response.data
            dispatch(fetchTrucksListingSuccess(fetchedTrucksListingResponse));
        })
        .catch((err) => {
            dispatch(fetchLoadsFail(err))
        })
    }
}


export const isCollectioRequired =(payload, props)=>{
        return (dispatch)=>{
            dispatch(fetchLoadsStart())
    
            let url =  `ulb/updateRepeatCollection`
            axios.put(url, payload,{headers:{
                "Authorization":`Bearer ${payload.token}`
            }})
            .then(function (response) {
                const fetchedDayData = response.data.success;
                fetchedDayData && swal({
                    title: "Repeat Collection Mode Updated",
                    icon: "success",
                    buttons: {
                        confirm: 'Ok'
                    }
                  })
                  props.history.push('/records/all')
                // window.location.reload();
            }, (err) => {
                swal({icon : "error" , title : err.response.data.error[0]["message"]})  
            })
            .catch(err => {
                dispatch(fetchLoadsFail(err))        
            })
            
        }
    }